/* eslint-disable arrow-body-style */
import React, { useState, useEffect } from "react";
import ReactGA from "react-ga4";
import { Link, useNavigate } from "react-router-dom";
import { Typography, Button, useWindowSize, Modal, ScalableImage } from "design_system/src";
import { ReactComponent as Right } from "design_system/src/static/icons/chevron-right.svg";

import uberLogo from "static/icons/uber_logo.png";
import didiLogo from "static/icons/didi_food.png";

import "./mainBanner.scss";
import { useDispatch } from "react-redux";
import {
  clearApplicationLoanTime,
  clearApplicationVehicle,
} from "store/actions/application";

const uber = "UBER";
const didi = "DIDI";

export const MainBanner = () => {
  const bannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/motos_pulsar_ls_125_nueva_small";
  const tabletBannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/motos_pulsar_ls_125_nueva_medium";
  const desktopBannerImg = "https://ik.imagekit.io/ozon/Homepage/Banner%20principal%20/motos_pulsar_ls_125_nueva_large";

  const { width: windowWidth } = useWindowSize();
  const [showModal, setShowModal] = useState<boolean>(false);

  const dispatch = useDispatch();

  const clickToFinancialForm = (alliedCompany: string  | null = null) => {
    dispatch(clearApplicationLoanTime());
    dispatch(clearApplicationVehicle());

    if (alliedCompany) {
      ReactGA.event("CTA_discount_delivery_drivers", {
        category: "Financial Form",
        label: "click modal of delivery drivers discount",
        value: alliedCompany
      });
    }
  };

  const renderButtons = () => {
    return (
      <div className="m_y_xl w_100_per display_flex flex_col flex_align_center">
        <div className={`w_100_per display_flex flex_align_center w_60_per_mobile ${windowWidth <= 800 ? " flex_col flex_justify_center flex_gap_xs" : " flex_justify_start flex_gap_md"}`}>
          <Link to="/financia-tu-moto" onClick={() => clickToFinancialForm()} className="w_100_per_mobile">
            <Button
              variant="principal"
              scale={windowWidth > 800 || windowWidth < 600 ? "small" : "small"}
              className="w_100_per_mobile"
            >
              <Typography weight="600" scale="small">Solicita tu crédito ahora</Typography>
            </Button>
          </Link>
          <Link to="/catalogo" className="w_100_per_mobile">
            <Button
              color="grey"
              orientation="right"
              scale={windowWidth > 800 || windowWidth < 600 ? "small" : "small"}
              icon={<Right />}
              className="w_100_per_mobile"
            >
              <Typography weight="600" scale="small">Ver catálogo de motos</Typography>
            </Button>
          </Link>
        </div>
        <div className={`w_100_per display_flex flex_align_center m_t_xl${windowWidth <= 800 ? " flex_col" : ""}`}>
          <Typography weight={windowWidth > 600 ? "400" : "600"} scale="medium" textColor="neutral_0">¿Eres repartidor?</Typography>
          <Button
            color="primary"
            variant="ghost"
            orientation="right"
            scale="small"
            icon={<Right />}
            className="w_100_per_mobile p_none"
            onClick={() => setShowModal(true)}
          >
            <Typography weight="600" scale={windowWidth > 800 ? "medium" : "small"}>¡Aprovecha este descuento!</Typography>
          </Button>
        </div>
        <div className={`w_100_per display_flex${windowWidth <= 800 ? " flex_center" : ""}`}>
          <Typography weight="400" scale="xsmall" textColor="neutral_0">*Aplica para modelos marcados en catálogo.</Typography>
        </div>
      </div>
    );
  };

  const renderTextContent = () => {
    return (
      <div className={`w_100_per p_t_xxxl_mobile p_x_lg_mobile${windowWidth <= 800 ? " text_center_desktop" : " p_r_xl"}`}>
        <Typography
          scale={windowWidth > 1280 ? "heading2" : "heading3"}
          scaleMobile="heading1"
          weight="600"
          textColor="neutral_0"
        >
          Compra tu moto nueva o
        </Typography>
        <Typography
          scale={windowWidth > 1280 ? "heading4" : "large"}
          scaleMobile="heading3"
          weight="600"
          textColor="neutral_0"
          className="p_b_xxl_mobile p_b_md_desktop"
        >
          seminueva desde <span className="bannerUnderline">240 pesos</span> semanales*
        </Typography>
        <Typography
          scale={windowWidth > 1280 ? "heading4" : "large"}
          scaleMobile="heading4"
          weight="400"
          textColor="neutral_0"
          className="p_b_lg_mobile p_b_sm bannerText"
        >
          Llévatela con nuestro <span className="text_primary_300">Buró Flexible, </span><br className="display_none_mobile"/>paga en <span className="text_primary_300">1 año</span> o hasta 156 semanas.
        </Typography>
        <Typography
          scale={windowWidth > 1280 ? "heading4" : "large"}
          scaleMobile="heading4"
          weight="400"
          textColor="neutral_0"
        >Disponible solo en Ciudad de México.</Typography>
      </div>
    );
  };

  return (
    <section className="bannerSection">
      <div className="bannerBaseImg__container">
        <ScalableImage
          // eslint-disable-next-line no-nested-ternary
          src={windowWidth >= 1024 ? desktopBannerImg : windowWidth >= 600 ? tabletBannerImg : bannerImg}
          alt="Compra tu moto nueva o seminueva desde 240 pesos semanales. Crédito con Buró Flexible, paga en 1 año o hasta 156 semanas. Solo en CDMX."
          className="bannerBaseImg"
          desktopWidth={windowWidth >= 1024 ? 80 : 50}
          mobileWidth={50}
        />
        <div className="bannerSection--pos-absolute">
          <div className="w_100_per h_100_per display_flex_desktop flex_row_desktop flex_justify_end_desktop">
            <div className={`w_100_per_mobile h_100_per_mobile display_flex flex_col flex_justify_between_mobile flex_justify_center_desktop ${windowWidth > 800 ? "w_40_per_desktop" : "w_50_per_desktop"}`}>
              {renderTextContent()}
              {renderButtons()}
            </div>
          </div>
        </div>
      </div>

      <Modal open={showModal} setOpen={setShowModal} className="alliedCardModal">
        <Typography weight="600" scale="heading4" textColor="primary_300" className="text_center">Tenemos descuentos especiales para repartidores</Typography>
        <Typography weight="400" scale="medium" className="text_center">Selecciona en que plataforma te encuentras como repartidor:</Typography>
        <div className="display_flex flex_col_mobile flex_gap_md flex_align_center flex_justify_center m_t_md">
          <Link to={`/financia-tu-moto?alliedCompany=${uber}`} onClick={() => clickToFinancialForm(uber)} className="w_100_per_mobile alliedCard__link">
            <div className="alliedCard">
              <img
                src={uberLogo}
                alt="Aliado Uber – Conoce beneficios exclusivos para repartidores"
              />
              <Typography weight="600" scale="medium" className="text_center">Ahorra hasta $10,700</Typography>
            </div>
          </Link>
          <Link to={`/financia-tu-moto?alliedCompany=${didi}`} onClick={() => clickToFinancialForm(didi)} className="w_100_per_mobile alliedCard__link">
            <div className="alliedCard">
              <img
                src={didiLogo}
                alt="Aliado Didi – Conoce beneficios exclusivos para repartidores"
              />
              <Typography weight="600" scale="medium" className="text_center">Ahorra hasta $7,700</Typography>
            </div>
          </Link>
        </div>
      </Modal>
    </section>
  );
};
